var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider"},[_c('div',{staticClass:"divider-content"},[_c('Divider',[_vm._v("分割线")]),_c('iDelModel',{attrs:{"del-model":_vm.delModel},on:{"upData":function($event){return _vm.$emit('upData')},"downData":function($event){return _vm.$emit('downData')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }